import script from "./HistoricalTaskForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricalTaskForm.vue?vue&type=script&setup=true&lang=js"

import "./HistoricalTaskForm.vue?vue&type=style&index=0&id=bdf84db4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdf84db4"]])

export default __exports__